const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//  GET
		// ===================================
		case "NEWS_ITEM_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "NEWS_ITEM_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "NEWS_ITEM_SUCCESS":
			return {
				...state,
				news: action.data.data,
				isLoading: 0
			};

		// ===================================
		//  CLEAR
		// ===================================
		case "NEWS_ITEM_CLEAR":
			return { ...initialState };

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/newsItem.js